import React, { useContext } from "react";
import { Box, Typography, Modal, Table, TableBody, TableCell, TableRow, useTheme, useMediaQuery, } from "@mui/material";
import Draggable from "react-draggable";
import { ThemeContext } from "../../context/ThemeContext";
import { CloseSharp } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const DraggableBox = React.forwardRef(({ children, ...props }, ref) => (
    <Draggable handle=".header"><div ref={ref} {...props}>{children}</div></Draggable>
));

const ContactUs = ({ isOpen, onClose }) => {
    const { darkMode } = useContext(ThemeContext);
    const { t } = useTranslation()
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    return (
        <Modal open={isOpen} onClose={onClose} aria-labelledby="contact-us-modal" aria-describedby="contact-us-description" closeAfterTransition components={{ BackdropProps: { timeout: 500, }, }}>
            <DraggableBox style={{
                position: "absolute",  top: isMobile ? "30%" : "30%", left: isMobile ? "5%" : "30%", transform: "translate(-50%, -50%)", backgroundColor: darkMode ? "#0f1720" : "var(--white)", boxShadow: darkMode
                    ? "0px 16px 46px 8px rgba(0, 0, 0, 0.12)" : "0 10px 20px rgba(169, 169, 169, 0.3), 4px 4px 10px rgba(169, 169, 169, 0.2), -4px 4px 5px rgba(169, 169, 169, 0.1)", overflow: "hidden", width: "90%", maxWidth: "600px",
            }}>

                <div className="header" style={{ padding: "10px 15px", cursor: "move", display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor: darkMode ? "#1976d2" : "#1976d2", color: "white", }}>
                    <Typography variant="body2" className="text-secondaryLight">{t('contactUs')}</Typography>
                    <CloseSharp style={{ cursor: "pointer" }} onClick={onClose} />
                </div>

                <Box sx={{ padding: "0px", backgroundColor: darkMode ? "#0f1720" : "var(--white)", color: darkMode ? "#d1d1d1" : "#333", }}>
                    <Table sx={{ borderCollapse: "separate", borderSpacing: "0 2px", }}>
                        <TableBody>
                            <TableRow>
                                <TableCell sx={{ fontSize: '13.5px', color: darkMode ? "#8a8a8a" : "#555", fontWeight: "bold", border: "none", padding: "7px 15px", }}>{t("company")}</TableCell>
                                <TableCell sx={{ fontSize: '13.5px', border: "none", padding: "7px 15px", }}>{process.env.REACT_APP_COMPANY_NAME}.</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell sx={{ fontSize: '13.5px', color: darkMode ? "#8a8a8a" : "#555", fontWeight: "bold", border: "none", padding: "7px 15px", }}>{t('registrationAddress')}</TableCell>
                                <TableCell sx={{ border: "none", padding: "7px 15px", }}> {process.env.REACT_APP_ADDRESS} </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell sx={{ fontSize: '13.5px', color: darkMode ? "#8a8a8a" : "#555", fontWeight: "bold", border: "none", padding: "7px 15px", }}>{t("website")}</TableCell>
                                <TableCell sx={{ border: "none", padding: "7px 15px", }}>                    <Typography variant="body2" className="text-primary"> <a href={process.env.REACT_APP_COMPANY_WEBSITE} target="_blank" rel="noopener noreferrer">{process.env.REACT_APP_COMPANY_WEBSITE}</a></Typography></TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell sx={{ color: darkMode ? "#8a8a8a" : "#555", fontWeight: "bold", border: "none", padding: "7px 15px", }}> {t("email")} </TableCell>
                                <TableCell sx={{ border: "none", padding: "7px 15px", }}><Typography variant="body2" className="text-primary"><a href={`mailto:${process.env.REACT_APP_COMPANY_EMAIL}`} style={{ color: 'inherit', textDecoration: 'none' }}>{process.env.REACT_APP_COMPANY_EMAIL}</a></Typography></TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Box>
            </DraggableBox>
        </Modal>
    );
};

export default ContactUs;


